export enum entityTypeMap {
  campaign = 'facebook.campaign',
  adSet = 'facebook.adSet',
  ad = 'facebook.ad',
  adAccount = 'facebook.adAccount',
  shopifyShop = 'shopify.shop',
}